<template>
	<div>
		<div class="single-gallery">
			<h1> {{ posts.name }} </h1>
			<p v-html="posts.description"> {{ posts.description }} </p>
			
			<ul id="aniimated-thumbnials" class="gallery-p">
				<li v-for="photo in photos" :data-src="photo.full">
					<img class="img-responsive" :src="photo.thumb" />
				</li>
			</ul>
		</div>
	</div>
</template>

<script type="text/javascript">

	module.exports = {

		data: function(){
			return {
				main: 'https://dnz-kalynka.pp.ua/api/photoalbum/',
				posts: []
			}
		},
		methods: {
			getContent: function(){
				var postId = this.$route.params.id
				this.$http.get(this.main + postId).then(function(response){
					this.posts = response.data
					this.photos = response.data.photos
				}, function(error){
					console.log('Помилка при отриманні даних')
				})
			}
		},
		created: function(){
			this.getContent()
		},
		watch: {
			'$route': {
				deep: true,
					handler: function (refreshPage) {
					this.getContent()
				}
			}
		},
		updated: function () {
			this.$nextTick(function () {
				$('#aniimated-thumbnials').lightGallery({
					share: false
				})
			})
		}
		
	}

</script>


// WEBPACK FOOTER //
// src/views/single-photo.vue